export * from './room.service';
export * from './room.model';
export * from './forbidden-name.directive';
